import React, { useState } from "react";
import { TablePagination } from "@mui/material";
import styles from "./agents.module.css";
import { AgentsHeader } from "./components/agentsHeader/agentsHeader.index";
import { AgentsTable } from "./components/agentsTable/agentsTable.index";
import { CreateDownlineModal } from "./components/createDownlineModal/createDownlineModal.index";
import { useAgentsPage } from "./agents.hooks";
import { useAgentsStore } from "./store/agents.store";
import {
    selectAgentsDetails,
    selectPageIndex,
    selectPageSize,
    selectSortRequest,
    selectTotalAgents,
} from "./store/agentsSelectors";
import { AGENTS_TBL_DEFAULT_VISIBLE_COLS } from "./agents.constants";
import { rowCountPerPageOptions } from "../../constants/rowsPerPageOptions";

const Agents = () => {
    const { handleChangePage, handleChangePageSize, handleSearch, handleSortChange } = useAgentsPage();
    const [visibleColumns, setVisibleColumns] = useState<string[] | null>([...AGENTS_TBL_DEFAULT_VISIBLE_COLS]);
    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [downlineModalOpen, setDownlineModalOpen] = useState(false);

    const agentsDetails = useAgentsStore(selectAgentsDetails);
    const pageSize = useAgentsStore(selectPageSize);
    const pageIndex = useAgentsStore(selectPageIndex);
    const totalAgents = useAgentsStore(selectTotalAgents);
    const sortRequest = useAgentsStore(selectSortRequest);

    return (
        <div className={styles.agentsContainer}>
            <AgentsHeader
                onSearch={handleSearch}
                visibleColumns={visibleColumns}
                setVisibleColumns={setVisibleColumns}
            />
            <div className={styles.tableCtn}>
                <AgentsTable
                    data={agentsDetails}
                    visibleColumns={visibleColumns}
                    sortRequest={sortRequest}
                    onSortChange={handleSortChange}
                    onCreateDownline={(userId) => {
                        setSelectedUserId(userId);
                        setDownlineModalOpen(true);
                    }}
                />
                <div className={styles.tablePaginationCtn}>
                    <TablePagination
                        count={totalAgents}
                        page={pageIndex - 1}
                        rowsPerPage={pageSize}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangePageSize}
                        rowsPerPageOptions={rowCountPerPageOptions}
                        component="div"
                    />
                </div>
            </div>
            <CreateDownlineModal
                open={downlineModalOpen}
                onClose={() => setDownlineModalOpen(false)}
                selectedUserId={selectedUserId}
            />
        </div>
    );
};

export default Agents;
